/** All supported Pusher channel event names. */
export const PUSHER_CHANNEL_EVENTS = [
  "file-ready",
  "download-completed",
  "encrypted-declaration-progress",
  "record-generation-progress",
  "notification",
  "admin-notification",
];

/** Events bound during the download flow. */
export const DOWNLOAD_CHANNEL_EVENTS = [
  "download-completed",
  "encrypted-declaration-progress",
];

/**
 * @typedef {"READY" | "PROCESSING" | "FAILED" | string} PusherFileStatus
 */

/**
 * @typedef {Object} EncryptedDeclarationProgress
 * @property {number} [current]
 * @property {number} [total]
 * @property {number} [percentage]
 */

/**
 * @typedef {"STARTED" | "PROGRESS" | "COMPLETED" | "FAILED" | string} EncryptedDeclarationStep
 */

/**
 * @typedef {Object} EncryptedDeclarationProgressPayload
 * @property {number} orderId
 * @property {number} filePasswordOtpId
 * @property {EncryptedDeclarationStep} step
 * @property {string} [message]
 * @property {EncryptedDeclarationProgress} [progress]
 * @property {number} [currentFileId]
 * @property {string} [currentFileName]
 * @property {number[]} [fileIds]
 * @property {string} [error]
 * @property {string} [timestamp]
 */

/**
 * @typedef {Object} DownloadCompletedPayload
 * @property {number} orderId
 * @property {number} filePasswordOtpId
 * @property {number[]} [fileIds]
 * @property {PusherFileStatus} status
 * @property {string} [generatedAt]
 * @property {string} [message]
 */

/**
 * @typedef {Object} NotificationPayload
 * @property {string|number} id
 * @property {string} [title]
 * @property {string} [message]
 * @property {string} [type]
 * @property {boolean} [isRead]
 * @property {Object} [metadata]
 */

/**
 * @typedef {Object} RecordGenerationProgressPayload
 * @property {number} orderId
 * @property {EncryptedDeclarationStep} step
 * @property {string} [message]
 * @property {EncryptedDeclarationProgress} [progress]
 * @property {number[]} [fileIds]
 * @property {string} [error]
 * @property {string} [timestamp]
 */

/**
 * @typedef {Object} PusherEventCallbacks
 * @property {(payload: DownloadCompletedPayload) => void} [onDownloadCompleted]
 * @property {(payload: EncryptedDeclarationProgressPayload) => void} [onEncryptedDeclarationProgress]
 * @property {(payload: RecordGenerationProgressPayload) => void} [onRecordGenerationProgress]
 * @property {(payload: NotificationPayload) => void} [onNotification]
 */
